var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQrcodeCircleColor = function SvgQrcodeCircleColor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1123_3974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z",
    fill: "#00D7B2",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53015 7.05874H8.11792C7.53315 7.05874 7.0591 7.53275 7.0591 8.11747V9.52959C7.0591 10.1143 7.53315 10.5883 8.11792 10.5883H9.53015C10.1149 10.5883 10.589 10.1143 10.589 9.52959V8.11747C10.589 7.53275 10.1149 7.05874 9.53015 7.05874ZM8.11792 6C6.94838 6 6.00027 6.94803 6.00027 8.11747V9.52959C6.00027 10.699 6.94838 11.6471 8.11792 11.6471H9.53015C10.6997 11.6471 11.6478 10.699 11.6478 9.52959V8.11747C11.6478 6.94802 10.6997 6 9.53015 6H8.11792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53011 8.82356C9.53011 9.21341 9.21405 9.52944 8.82417 9.52944C8.43429 9.52944 8.11823 9.21341 8.11823 8.82356C8.11823 8.43371 8.43429 8.11768 8.82417 8.11768C9.21405 8.11768 9.53011 8.43371 9.53011 8.82356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53029 13.4117H8.11806C7.53329 13.4117 7.05924 13.8857 7.05924 14.4704V15.8826C7.05924 16.4673 7.53329 16.9413 8.11806 16.9413H9.53029C10.1151 16.9413 10.5891 16.4673 10.5891 15.8826V14.4704C10.5891 13.8857 10.1151 13.4117 9.53029 13.4117ZM8.11806 12.353C6.94851 12.353 6.00041 13.301 6.00041 14.4704V15.8826C6.00041 17.052 6.94852 18 8.11806 18H9.53029C10.6998 18 11.6479 17.052 11.6479 15.8826V14.4704C11.6479 13.301 10.6998 12.353 9.53029 12.353H8.11806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53011 15.1765C9.53011 15.5663 9.21405 15.8823 8.82417 15.8823C8.43429 15.8823 8.11823 15.5663 8.11823 15.1765C8.11823 14.7866 8.43429 14.4706 8.82417 14.4706C9.21405 14.4706 9.53011 14.7866 9.53011 15.1765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8838 13.4117H14.4715C13.8868 13.4117 13.4127 13.8857 13.4127 14.4704V15.8826C13.4127 16.4673 13.8868 16.9413 14.4715 16.9413H15.8838C16.4685 16.9413 16.9426 16.4673 16.9426 15.8826V14.4704C16.9426 13.8857 16.4685 13.4117 15.8838 13.4117ZM14.4715 12.353C13.302 12.353 12.3539 13.301 12.3539 14.4704V15.8826C12.3539 17.052 13.302 18 14.4715 18H15.8838C17.0533 18 18.0014 17.052 18.0014 15.8826V14.4704C18.0014 13.301 17.0533 12.353 15.8838 12.353H14.4715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8836 15.1765C15.8836 15.5663 15.5675 15.8823 15.1776 15.8823C14.7878 15.8823 14.4717 15.5663 14.4717 15.1765C14.4717 14.7866 14.7878 14.4706 15.1776 14.4706C15.5675 14.4706 15.8836 14.7866 15.8836 15.1765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5304 8.82359C12.5304 7.36178 13.7157 6.17657 15.1776 6.17657V7.23531C14.3005 7.23531 13.5892 7.9465 13.5892 8.82359H12.5304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7661 8.82371V7.76471H17.8249V8.82371C17.8249 10.2855 16.6397 11.4705 15.1778 11.4705H13.7658V10.4118H15.1778C16.055 10.4118 16.7661 9.70079 16.7661 8.82371Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1123_3974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQrcodeCircleColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "qrcode-circle-color.6713344df90f73f8e38472a060ea9824.svg";